import { Model as c } from "../../../../../model.js";
class s extends c {
  constructor(e) {
    super(), this.initialBalance = e.initialBalance, this.cycle = e.cycle, this.conversionRules = e.conversionRules;
  }
}
export {
  s as TierSettingsModel
};
//# sourceMappingURL=tierSettings.model.js.map
